<template>
 <Head>
    <title> Admin Competency Matrix Report | {{$page.props.appName}}</title>
    <meta name="description" :content="'Competency Matrix Report ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
        <h1 class="text-2xl font-semibold ml-5">Competency Matrix</h1>
         <p class="ml-5">Please select your filter options below in order to generate the report.</p>
          <form @submit.prevent="store">
          
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                <div class="pr-6 pb-8 w-full lg:w-1/2">
                <label for="text-input-21" class="form-label">Site:</label>
                <select class="form-select" v-model="this.form.site" multiple>
                  <option value="ALL">ALL</option>
                  <option v-for="site in sites" :key="site.id" :value="site.id"> {{site.site_name}} </option>
                </select>
              </div>
              <div class="pr-6 pb-8 w-full lg:w-1/2">
                <label for="text-input-22" class="form-label"
                  >Department:</label
                >
                <select class="form-select" v-model="this.form.department" multiple>
                  <option value="ALL">ALL</option>
                  <option v-for="department in departments" :key="department.id" :value="department.id"> {{department.department_name}} </option>
                </select>

              </div>
              <div class="pr-6 pb-8 w-full lg:w-1/2">
                <label for="text-input-22" class="form-label"
                  >Skills:</label
                >
                <select class="form-select" v-model="this.form.skill" multiple>
                  <option value="ALL">ALL</option>
                  <option v-for="skill in skills" :key="skill.id" :value="skill.id"> {{skill.skill_name}} </option>
                </select>
              </div>
            
            </div>
          </form>

       <div class="w-full">
            <a :href="'/admin/reports/compmatrix/excel?site='+this.form.site +'&department=' + this.form.department + '&skill=' + this.form.skill"><button type="submit" class="bg-black text-white font-bold p-2 ml-6 mt-3 float-left">GENERATE EXCEL SPREADSHEET </button></a>

            <button type="submit" class="bg-black text-white font-bold p-2 ml-6 mt-3 float-right" @click="store()" :disabled="form.processing">GENERATE REPORT </button>

          </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head },
  props: {
    sites: Object,
    departments: Object,
    skills : Object
  },
  data() {
    return {
      form: this.$inertia.form({
        site: "ALL",
        department: "ALL",
        skill : "ALL"
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/reports/compmatrix");

    }
   
  },
};
</script>
     